export default __webpack_public_path__ + "static/media/renameIcon.1d036d46.svg";